module.exports = __webpack_public_path__ + "img/@ico_write_hand.00d4edf8.png";